import { render } from "./SupremaView.vue?vue&type=template&id=04b78d9c"
import script from "./SupremaView.vue?vue&type=script&lang=js"
export * from "./SupremaView.vue?vue&type=script&lang=js"

import "./SupremaView.vue?vue&type=style&index=0&id=04b78d9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__